import { useMemo, useRef, useState } from "react";
import {
  Box,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { setLayout } from "../../src/redux/actions/layout";
import PmsSearchContactDetails from "../../src/pms-search/forms/PmsSearchContactDetails";
import NavbarPmsSearch from "../../src/navigation/navbar/NavbarPmsSearch";
import PmsSearchPreferencesForm from "../../src/pms-search/forms/PmsSearchPreferencesForm";
import PmsSearchMedicalForm from "../../src/pms-search/forms/PmsSearchMedicalForm";
import PmsSearchPaymentForm from "../../src/pms-search/forms/PmsSearchPaymentForm";
import LogInModal from "../../src/authentication/LogInModal";
import LoadingSpinner from "../../src/components/common/LoadingSpinner";
import PmsSearchSessionDetailsForm from "../../src/pms-search/forms/PmsSearchSessionDetailsForm";
import PmsSearchSymptomDetails from "../../src/pms-search/forms/PmsSearchSymptomDetails";
import { useUser } from "../../src/hooks/useUser";
import { getData } from "../../src/utilities/axios";
import Head from "next/head";

const FindAPractitioner = () => {
  const dispatch = useDispatch();

  // Redux state
  const state = useSelector((state) => state);
  const pmsSearch = useSelector((state) => state.pmsSearch);
  const [loaded, loggedIn] = useUser();
  const [displayNotice, setDisplayNotice] = useState(false);
  const pmsStep = state.layout.pmsSearchStep;
  const [utilData, setUtilData] = useState();
  const [localUtilLoaded, setLocalUtilLoaded] = useState(false);

  const cancelRef = useRef();
  const router = useRouter();

  const formSection = useMemo(() => {
    switch (pmsStep) {
      case 0:
        return <PmsSearchContactDetails utilData={utilData} />;
      case 1:
        return <PmsSearchSymptomDetails utilData={utilData} />;
      case 2:
        return <PmsSearchPreferencesForm utilData={utilData} />;
      case 3:
        return <PmsSearchSessionDetailsForm utilData={utilData} />;
      case 4:
        return <PmsSearchMedicalForm utilData={utilData} />;
      case 5:
        return <PmsSearchPaymentForm utilData={utilData} />;
      default:
        return <h1>OOOOPS! Nothing Here</h1>;
    }
  }, [pmsStep, utilData]);

  useEffect(() => {
    if (loaded && !loggedIn) {
      setDisplayNotice(true);
    }
  }, [loaded, loggedIn]);

  useEffect(() => {
    const getUtilData = async () => {
      const utils = await getData(
        `${process.env.NEXT_PUBLIC_NEW_UTILITIES_URL}utilities`,
        process.env.NEXT_PUBLIC_NEW_UTILITIES_APIKEY
      );
      setUtilData(utils);
      setLocalUtilLoaded(true);
    };
    getUtilData();
  }, []);

  return loaded && localUtilLoaded ? (
    <>
      <Head>
        <title>Welldoing.org - Matching Service</title>
        <meta name="title" content="Welldoing.org - Matching Service" />
        <meta name="description" content="Welldoing.org - Matching Service" />
        <meta
          name="og:description"
          content="Welldoing.org - Matching Service"
        />
        <link rel="canonical" href={`https://welldoing.org/matching-service`} />
      </Head>
      {/* Navbar */}
      <NavbarPmsSearch />
      <Box height="90px"></Box>

      {/* Log In modal */}
      {!loggedIn && (
        <LogInModal
          title="Sign up to submit a MatchPlus request"
          emailValidation="false"
          signUpChoice="client"
          noRedirect
          noClose
          onCloseModal={() => {
            router.push("/");
          }}
        />
      )}
      {loggedIn && formSection}
    </>
  ) : (
    <LoadingSpinner />
  );
};

export default FindAPractitioner;
